<!--
 * @Descripttion: 
 * @version: 
 * @Author: tangyuan
 * @Date: 2020-11-23 14:30:59
 * @LastEditors: tangyuan
 * @LastEditTime: 2021-01-29 16:19:21
-->
<template>
    <div class="nav">
        <div class="main-box">
            <div class="logo">
                <img :src="LogoImg" alt="">
            </div>
            <div class="route">
                <router-link target="_blank" to="/home">网站首页</router-link>
                <router-link target="_blank" to="/introduction">公司介绍</router-link>
                <router-link target="_blank" to="/business_index">主营业务</router-link>
                <router-link target="_blank" to="/cooperation_brand">合作品牌</router-link>
                <!-- <router-link to="/cooperation_business">商务合作</router-link> -->
            </div>
        </div>
    </div>
</template>

<script>
import LogoImg from '@/assets/images/logo.png'
    export default {
        name:'Nav',
        data() {
            return {
                LogoImg:LogoImg
            }
        },
    }
</script>

<style lang="scss" scoped>
.nav {
    position: fixed;
    width: 100%;
    height: 80px;
    line-height: 80px;
    font-size: 18px;
    background-color: rgba(20, 20, 20, .8);
    z-index: 999;
    .main-box{
        display: flex;
    }
    .logo{
        width: 160px;
        height: 60px;
        opacity: 1;
        img{
            width: 160px;
            height: 60px;
        }
    }
    .route{
        a {
            display: inline-block;
            width: 80px;
            height: 28px;
            line-height: 28px;
            color: #fff;
            position: relative;
            margin: 0 55px;
            cursor: pointer;
            text-align: center;
            &.router-link-active {
                // color: #42b983;
                &::after{
                    position: absolute;
                    content: '';
                    bottom: -2px;
                    left: 50%;
                    transform: translate(-50%);
                    width: 80px;
                    height: 3px;
                    background-color: #841b2c;
                }
            }
        }
    }
}
</style>